<template>
  <div class="search-container">
    <el-form
      :inline="true"
      :model="searchParams"
      size="small"
      label-width="120px"
    >
      <el-form-item label="">
        <el-select
          v-model="searchParams.pushType"
          multiple
          collapse-tags
          placeholder="请选择通知类型"
          style="width: 240px"
          clearable
        >
          <el-option label="消息盒子" :value="1"></el-option>
          <el-option label="push提醒" :value="2"></el-option>
          <el-option label="短信通知" :value="3"></el-option>
          <el-option label="公众号" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="searchParams.id"
          placeholder="请输入通知ID"
          style="width: 240px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select
          v-model="searchParams.status"
          placeholder="请选择状态"
          style="width: 200px"
          clearable
        >
          <el-option label="上线" value="1"></el-option>
          <el-option label="下线" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          v-model="searchParams.reviewStatus"
          placeholder="请选择审核状态"
          style="width: 200px"
          clearable
        >
          <el-option label="草稿" :value="0"></el-option>
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="审核通过" :value="2"></el-option>
          <el-option label="审核拒绝" :value="3"></el-option>
          <el-option label="撤销审核" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          v-auth="'NOTICE_MANAGE_SEARCH'"
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleSearch"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { exportNotice } from "@/api/noticeManage/noticeManage";
import Message from "@/components/Message";
export default {
  name: "NoticeManageSearch",
  inject: ["searchParams", "list", "getList"],
  data() {
    return {
      selectedRows: [],
    };
  },
  methods: {
    /** 搜索 */
    handleSearch() {
      this.searchParams.current = 1;
      this.getList();
      Message.success("搜索成功");
    },
    /** 清空 */
    handleReset() {
      this.searchParams.pushType = [];
      this.searchParams.id = "";
      this.searchParams.status = "";
      this.searchParams.reviewStatus = "";
      this.searchParams.current = 1;
      this.getList();
    },
    /** 导出 */
    async handleExport() {
      try {
        const params = { ...this.searchParams };
        // 处理多选的通知类型
        if (
          params.pushType &&
          Array.isArray(params.pushType) &&
          params.pushType.length > 0
        ) {
          params.pushType = params.pushType.join(",");
        }
        const response = await exportNotice(params);
        // 创建下载链接
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `通知公告_${new Date().getTime()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        Message.success("导出成功");
      } catch (error) {
        console.error("导出失败", error);
        Message.error("导出失败");
      }
    },
    /** 删除 */
    handleDelete() {
      // 触发父组件或table组件的删除方法
      this.$parent.$children.forEach((child) => {
        if (
          child.handleBatchDelete &&
          typeof child.handleBatchDelete === "function"
        ) {
          child.handleBatchDelete();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  margin-bottom: 20px;
}

.search-card {
  .el-form {
    margin-bottom: 10px;
  }
}

.search-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
</style>
